export default function CalendarIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33333 9.33333H8V12M10.6667 1.33333V4M2 6.66667H14M5.33333 1.33333V4M3.33333 2.66667H12.6667C13.403 2.66667 14 3.26362 14 4V13.3333C14 14.0697 13.403 14.6667 12.6667 14.6667H3.33333C2.59695 14.6667 2 14.0697 2 13.3333V4C2 3.26362 2.59695 2.66667 3.33333 2.66667Z"
        stroke="#9CA3AF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
